import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Newspaper } from "lucide-react";

export default function TradingViewNews({ height = 720 }) {
  const { t, i18n } = useTranslation();
  const locale = (i18n.language || "en").slice(0, 2);
  // Isolated in an iframe so the third-party script can't throw into our app.
  const srcDoc = useMemo(() => {
    const cfg = JSON.stringify({
      feedMode: "market", market: "forex", isTransparent: true, displayMode: "regular",
      width: "100%", height: "100%", colorTheme: "light", locale,
    });
    return `<!doctype html><html><body style="margin:0;height:100vh"><div class="tradingview-widget-container" style="height:100%"><div class="tradingview-widget-container__widget" style="height:100%"></div><script src="https://s3.tradingview.com/external-embedding/embed-widget-timeline.js" async>${cfg}</script></div></body></html>`;
  }, [locale]);

  return (
    <div data-testid="resources-market-news" className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
      <div className="px-5 py-4 border-b border-slate-200 flex items-center gap-2">
        <Newspaper size={16} className="text-blue-800" />
        <div className="text-sm font-semibold text-slate-900">{t("news.title")}</div>
        <span className="ml-auto text-[10px] uppercase tracking-widest text-slate-400">{t("news.source")}</span>
      </div>
      <iframe title={t("news.title")} srcDoc={srcDoc} className="w-full border-0 block" style={{ height }} data-testid="resources-market-news-frame" />
    </div>
  );
}
